import React from 'react'
import PayrollHeader from '../components/Organisms/Headers/PayrollHeader'
import SummaryPayrollPanel from '../components/Organisms/Panels/SummaryPayrollPanel'
import PeriodPayroll from '../components/Organisms/Panels/PeriodPayroll'
import NotesPayrollPanel from '../components/Organisms/Panels/NotesPayrollPanel'
import {useMedia} from '../hooks/useMedia'
import {mediaFromLg} from '../helpers/media-queries'
import TabsWrapper from '../components/Wrappers/TabsWrapper'
import PanelTemplate from '../components/Wrappers/PanelTemplate'
import PayrollTable from '../components/Organisms/Tables/PayrollTable'
import TabTemplate from '../components/Atoms/Templates/TabTemplate'

const PayrollDashboard = () => {
  const fromLg = useMedia(mediaFromLg)

  return (
    <div className="ed-grid row-gap">
      <PayrollHeader />
      {/* Contenido en computadoras */}

      {fromLg ? (
        <div className="ed-grid lg-grid-4 row-gap">
          <SummaryPayrollPanel />
          <PeriodPayroll />
          <NotesPayrollPanel />
        </div>
      ) : (
        // Contenido en tabletas y celulares
        <TabsWrapper>
          <div className="tab-container s-cross-center">
            <TabTemplate index={0} className="tab-item">
              Resumen
            </TabTemplate>
            <TabTemplate index={1} className="tab-item">
              Períodos
            </TabTemplate>
            <TabTemplate index={2} className="tab-item">
              Notas
            </TabTemplate>
          </div>
          <PanelTemplate index={0}>
            <SummaryPayrollPanel />
          </PanelTemplate>
          <PanelTemplate index={1}>
            <PeriodPayroll />
          </PanelTemplate>
          <PanelTemplate index={2}>
            <NotesPayrollPanel />
          </PanelTemplate>
        </TabsWrapper>
      )}

      <PayrollTable />
    </div>
  )
}

export default PayrollDashboard
